import { lazy } from 'react';

import type { TApplicationRoute } from '@modules/core/types';

import { COMMUNICATIONS_ROUTE_PATHS } from './config';
import { MESSAGE_TEMPLATES_ROUTE_PATHS } from './message-templates/config';

export const COMMUNICATIONS_ROUTES: TApplicationRoute[] = [
  {
    id: 'communications',
    path: COMMUNICATIONS_ROUTE_PATHS.communications,
    component: lazy(() => import('./pages/communications-page')),
    layout: 'default',
    permissions: { scopes: ['communications'] },
    menu: {
      title: 'pages.users.communications.title',
    },
  },
  {
    id: 'edit-message-template',
    path: MESSAGE_TEMPLATES_ROUTE_PATHS.editMessageTemplate,
    component: lazy(() => import('./message-templates/pages/edit-template-page')),
    layout: 'default',
    permissions: { scopes: ['communications'] },
  },
  {
    id: 'inspect-message-template',
    path: MESSAGE_TEMPLATES_ROUTE_PATHS.inspectMessageTemplate,
    component: lazy(() => import('./message-templates/pages/inspect-template-page')),
    layout: 'default',
    permissions: { scopes: ['communications'] },
  },
];
